import React from 'react'
import { motion } from "framer-motion";

const About = () => {
  return (
    <div name="about" className="w-full  h-fit sm:h-screen bg-gradient-to-b from-gray-300 to-gray-200 dark:bg-gradient-to-b dark:from-gray-800 dark:to-gray-700  scroll-mt-20">
              <motion.div initial={{ opacity: 0, x: 100 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 1 }}
    viewport={{ once: true, amount: 0.35 }} className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-fit">
        <div className="pb-4">
          <p className="text-4xl font-bold inline border-b-4 border-gray-800 text-gray-800 dark:text-gray-200 dark:border-gray-200">
            About
          </p>
        </div>
        <p className="text-0.5xl sm:text-xl mt-5  text-gray-800 dark:text-gray-200">
        Driven by a deep passion for Information Technology, I am a dedicated computer engineer eager to make my mark in the industry. With a solid foundation in HTML, CSS, and JavaScript, along with practical experience in React, I thrive on building interactive and visually appealing user interfaces. Proficient in version control using Git and GitHub, I am adept at collaborating with teams to deliver high-quality projects.As an IT intern, I got to learn about AD, VLAN and other networking stuffs.
        </p>

        <br />

        <p className="text-0.5xl sm:text-xl  text-gray-800 dark:text-gray-200">
        Beyond coding, I find joy in adventurous travel to explore new places, immersing myself in captivating web series and anime, and indulging in friendly matches of cricket and table tennis. My multicultural background has endowed me with fluency in English, Nepali, Maithili, and Hindi, facilitating effective communication and collaboration.
        </p>
        <div className='my-10'>
          <a href="/SATYAM KUMAR SINGH.pdf" className="text-white w-fit px-6 py-3 my-2 rounded-md bg-orange-400 cursor-pointer" download="SATYAM KUMAR SINGH" >Download CV</a>
        </div>
      </motion.div>

    </div>
  )
}

export default About